import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateImage from './components/Image';
import LearnMoreLink from './components/LearnMoreLink';
import UnlockButton from './components/UnlockButton';

import { userHasFeature } from '../../helpers/Features';

const EmptyMetadataMapping = ({ handleNewItem }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Apply workspace metadata on download' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Sync metadata added to your files in your workspace to EXIF, IPTC, and/or XMP fields and never lose a tag or description.' })}
        </div>
        <div>
          {userHasFeature('download-file-with-metadata') ? (
            <Button color="primary" className="mt-4" onClick={handleNewItem}>
              {intl.formatMessage({ defaultMessage: 'Map your metadata' })}
            </Button>
          ) : (
            <UnlockButton feature="download-file-with-metadata" />
          )}
          <LearnMoreLink url="https://help.stockpress.co/en/articles/8381132-metadata-mapping" />
        </div>
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-metadata-mapping.png" height="high" />
    </div>
  );
};

EmptyMetadataMapping.propTypes = {
  handleNewItem: PropTypes.func,
};

EmptyMetadataMapping.defaultProps = {
  handleNewItem: () => { },
};

export default EmptyMetadataMapping;
